// ─── Una cola por llave: lo que no puede correr dos veces a la vez ──────────
// Las sincronizaciones de costos (OCP y CxP) leen los conceptos, crean
// documentos con varios `await` de por medio y al final anotan en cada
// concepto qué documento le nació. Dos ejecuciones SIMULTÁNEAS sobre la misma
// orden —un doble clic en «Guardar costos»— leen las dos el mismo estado "sin
// documento" y crean las dos.
//
// Pasó de verdad: la OP-0219 quedó con DIEZ cuentas por pagar en vez de cinco,
// creadas con un segundo de diferencia por la misma persona y con los
// consecutivos intercalados (CXP-0005, 0006, 0008… y 0007, 0009, 0011…). La
// orden quedó apuntando a la segunda tanda; la primera quedó huérfana con sus
// cinco asientos de causación: $690.000 de pasivo que nunca existió.
//
// La cura es ponerlas en fila: la segunda espera a que termine la primera y
// solo entonces corre, ya con los conceptos marcados, así que no crea nada. Es
// una promesa encadenada por llave; si la anterior falló, la siguiente corre
// igual (el `catch` no deja que un error de ayer bloquee la cola para siempre).
const colas = new Map();

export function enSerie(clave, fn) {
  const anterior = colas.get(clave) || Promise.resolve();
  const propia = anterior.catch(() => {}).then(fn);
  colas.set(clave, propia);
  // Cuando esta termina (bien o mal) y nadie más se encoló detrás, la llave se
  // suelta para no acumular promesas resueltas por cada orden que se tocó.
  propia.catch(() => {}).finally(() => { if (colas.get(clave) === propia) colas.delete(clave); });
  return propia;
}

// Cuántas ejecuciones hay en fila para una llave: solo para pruebas y diagnóstico.
export function enColaPara(clave) {
  return colas.has(clave);
}
